import {toast} from "react-toastify"

export function SuccessToast(message) {
  return toast(message, {type: "success"})
}

export function ErrorToast(message) {
  return toast(message, {type: "error"})
}